import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import { environment } from "../../../environments/environment";
import "rxjs/add/operator/map";
import { CreateEstimateExternal, IEstimateExternal } from "../../master-models/estimate-external.model";
import { CreateEstimateExternalDetails, IEstimateExternalDetails } from "../../master-models/estimate-external-details.model";
import { Observable } from "rxjs";
import { IEstimateExternalPDF } from "../../master-models/estimate-external-pdf.model";

@Injectable()
export class EstimateExternalService {
  apiEndPoint = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getEstimateExternalList(
    startDate?: string,
    endDate?: string,
    customerId?: number,
  ): Observable<{success: boolean, data: IEstimateExternal[]}> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('start_date', startDate);
    }
    if (endDate) {
      params = params.set('end_date', endDate);
    }
    if (customerId) {
      params = params.set('customer_id', customerId.toString());
    }

    return this.http.get<{success: boolean, data: IEstimateExternal[]}>(`${this.apiEndPoint}api/estimates_external`, {
      headers: this.getHeaders(),
      params: params
    });
  }
  
  getEstimateExternal(id: number): Observable<{success: boolean, data: IEstimateExternal}> {
    return this.http.get<{success: boolean, data: IEstimateExternal}>(`${this.apiEndPoint}api/estimate_external/${id}`, {
      headers: this.getHeaders()
    });
  }

  createEstimateExternal(createEstimateExternal: CreateEstimateExternal): Observable<{success: boolean, estimate_external: IEstimateExternal}> {
    return this.http.post<{success: boolean, estimate_external: IEstimateExternal}>(`${this.apiEndPoint}api/estimate_external`, createEstimateExternal, {
      headers: this.getHeaders()
    });
  }
  
  updateEstimateExternal(id: number, updateEstimateExternal: IEstimateExternal): Observable<{success: boolean, estimate_external: IEstimateExternal}> {
    return this.http.put<{success: boolean, estimate_external: IEstimateExternal}>(`${this.apiEndPoint}api/estimate_external/${id}`, updateEstimateExternal, {
      headers: this.getHeaders()
    });
  }
  
  createEstimateExternalDetails(createEstimateExternalDetails: CreateEstimateExternalDetails): Observable<{success: boolean, estimate_external_detail: IEstimateExternalDetails}> {
    return this.http.post<{success: boolean, estimate_external_detail: IEstimateExternalDetails}>(`${this.apiEndPoint}api/estimate_external_detail`, createEstimateExternalDetails, {
      headers: this.getHeaders()
    });
  }

  updateEstimateExternalDetails(id: number, updateEstimateExternalDetails: IEstimateExternalDetails): Observable<{success: boolean, estimate_external_detail: IEstimateExternalDetails}> {
    return this.http.put<{success: boolean, estimate_external_detail: IEstimateExternalDetails}>(`${this.apiEndPoint}api/estimate_external_detail/${id}`, updateEstimateExternalDetails, {
      headers: this.getHeaders()
    });
  }
  
  deleteEstimateExternalDetails(id: number) {
    return this.http.delete(`${this.apiEndPoint}api/estimate_external_detail/${id}`, {
      headers: this.getHeaders()
    });
  }
  
  getEstimateExternalPDF(id: number): Observable<{success: boolean, pdf: IEstimateExternalPDF}> {
    return this.http.get<{success: boolean, pdf: IEstimateExternalPDF}>(`${this.apiEndPoint}api/estimate_external_pdf/${id}`, {
      headers: this.getHeaders()
    });
  }

  getHeaders(): HttpHeaders {
    const token = localStorage.getItem("token_user");
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/master-services/estimate-external/estimate-external.service.ts